// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@awc/App/Components/Notify";
import { accountSettingsDefaultBillingShippingStyles } from "@awc/Overrides/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.headingText = {
    as: "h5",
    variant: "h4",
};

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = {
    as: "h2",
    variant: "h4",
};

accountSettingsDefaultBillingShippingStyles.defaultCustomerMessage = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        display: block;
        margin-bottom: 12px;
    `,
};

accountSettingsDefaultBillingShippingStyles.selectSectionGridContainer = {
    gap: 0,
    offsetCss: css`
        gap: 24px;
    `,
};

accountSettingsDefaultBillingShippingStyles.notifyStyles = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin: 0;
            max-width: 500px;
        `,
    }),
};

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    gridContainer: {
        gap: 0,
        css: css`
            margin-bottom: 24px;
        `,
    },
    headingGridItem: {
        width: 12,
        css: css`
            align-items: baseline;
            gap: 24px;
            ${xScreen("lte", "xs")} {
                justify-content: space-between;
            }
        `,
    },
    headerText: {
        variant: "h4",
        as: "h5",
    },
    changeLink: {
        typographyProps: {
            size: fontConfig.fontSize.small,
            weight: fontConfig.weight.bold,
            css: css`
                line-height: ${fontConfig.lineHeight.singleLineRegular};
            `,
        },
        css: css`
            margin-left: 10px;
            margin-top: 10px;
            white-space: nowrap;
        `,
    },
    warehouseGridItem: {
        width: 12,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
        },
    },
};

accountSettingsDefaultBillingShippingStyles.container = {
    css: css`
        margin-top: 20px;
    `,
};
